import Vue from "vue"
import App from "@/App.vue"
import "./registerServiceWorker"
import VueProgressBar from "vue-progressbar"
import "@/assets/styles/main.scss"
import Notifications from "vue-notification";



Vue.use(Notifications);
Vue.use(VueProgressBar);

Vue.config.productionTip = false;

new Vue({
    render: h => h(App)
}).$mount("#app");
